import { render } from "./UploadImageShowModal.vue?vue&type=template&id=1521a736&scoped=true"
import script from "./UploadImageShowModal.vue?vue&type=script&lang=js"
export * from "./UploadImageShowModal.vue?vue&type=script&lang=js"

import "./UploadImageShowModal.vue?vue&type=style&index=0&id=1521a736&lang=css"
import "./UploadImageShowModal.vue?vue&type=style&index=1&id=1521a736&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1521a736"]])

export default __exports__